import { render } from "./v-editProduct.vue?vue&type=template&id=5b9dab2c"
import script from "./v-editProduct.vue?vue&type=script&lang=js"
export * from "./v-editProduct.vue?vue&type=script&lang=js"

import "./v-editProduct.vue?vue&type=style&index=0&id=5b9dab2c&lang=css"
script.render = render

export default script